import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Banner.css";
import Download_Btn from "./../../common/download-btn/Download_Btn";
import Apply_Now_Btn from "./../../common/apply-now-btn/Apply_Now_Btn";
import Apply_Modal from "../../apply-modal/Apply_Modal";
import { useDispatch, useSelector } from "react-redux";
import { AllAppSetup } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const ProgramBanner = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const [show, setShow] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const dispatch = useDispatch();

  const appsetup = useSelector((state) => state.common.all_app_setup);

  const brochure = appsetup?.brochure;

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);

  const handleDownload = () => {
    if (!brochure) {
      alert("Brochure PDF is not avialable");
      return;
    }

    const fullPDFUrl = `${IDS.IMG_URL}${brochure}`;

    window.open(fullPDFUrl, "_blank");
  };
  return (
    <section className="program-banner" ref={ref}>
      <div className="video-section">
        <video autoPlay muted loop playsInline className="background-video">
          <source src="/assets/videos/pst-video.mp4" type="video/mp4" />
        </video>
        <div className="video-overlay"></div>
      </div>
      <Container>
        <Row className="content">
          {/* Left Content */}
          <Col lg={6} sm={12} md={6} className="text-white left-content">
            <p className="sub-heading">
              India’s Leading Industry-Integrated Tech Institute
            </p>

            <h1 className="main-heading">
              Empowering Careers Through Technology,<br />
              <span>Innovation & Industry Excellence</span>
            </h1>

            <p className="description">
              PST IT Solutions bridges the gap between learning and industry by delivering practical, career-oriented training that prepares learners for real-world technology roles.
            </p>

            <div className="banner-buttons">
              <Apply_Now_Btn onClick={() => setShow(true)} />
              <Download_Btn
                onClick={handleDownload}
                disabled={downloading || !brochure}
              />
            </div>
          </Col>

          <Col lg={6} sm={12} md={6} className="right-image-card">
            <div className="image-card">
              <img
                src="/assets/images/pst_it_solution/banner/right-img.png"
                alt="Student"
                className="img-fluid"
              />

              <div className="stats-row">
                <div>
                  <h4>
                    {inView && <CountUp end={12} duration={2}
                    //  decimals={1}
                      />} LPA
                  </h4>
                  <p>average package</p>
                </div>

                <div>
                  <h4>
                    {inView && <CountUp end={91} duration={2} /> }%
                  </h4>
                  <p>Placement Percentage</p>
                </div>

                <div>
                  <h4>
                    {inView && <CountUp end={58} duration={2} /> } LPA
                  </h4>
                  <p>Highest Package</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Apply_Modal show={show} handleClose={() => setShow(false)} />
    </section>
  );
};

export default ProgramBanner;
